import React, { useCallback, useState } from "react";

import { FabricPreviewChangesDrawer } from "src/pages/candidates/fabricPreviewChangesDrawer";

interface PreviewChangesDrawerSchema {
  previewChangesDrawer: React.ReactElement | null;
  openPreviewChangesDrawer: () => void;
}
export const usePreviewChangesDrawer = (): PreviewChangesDrawerSchema => {
  const [previewChangesDrawer, setPreviewChangesDrawer] =
    useState<React.ReactElement | null>(null);

  const openPreviewChangesDrawer = useCallback(() => {
    const onClose = () => {
      setPreviewChangesDrawer(null);
    };
    setPreviewChangesDrawer(<FabricPreviewChangesDrawer onClose={onClose} />);
  }, []);

  return { previewChangesDrawer, openPreviewChangesDrawer };
};
